import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const BundleRecommenderLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleRecommender } = await import("@workflows/bundles/recommender");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_RECOMMENDER}>
      <BundleRecommender />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
